import React, { useState, useEffect } from "react";
import { confetti } from "../../../assets/confetti";
import StripeButton from "../../Account/StripeButton";
import { useHistory } from "react-router-dom";

export default function FinishSectionSuccess({ canvas }) {

	const [confettiPlaying, setConfettiPlaying] = useState(null);
	const history = useHistory();

	useEffect(() => {
		if (canvas.current && !confettiPlaying) {
			setConfettiPlaying(true);
			const stopConfetti = confetti(canvas.current);
			setTimeout(stopConfetti, 4000);
		}
	}, [canvas, confettiPlaying]);

	return <div className="form-section finishSection">
		<div className="inner">
			<h2>Success!</h2>
			<div className="details">
				Your shop has been created! There's a couple of things you need to do now.
				<br /><br />
				Firstly, you need to follow the Stripe setup so that you can actually get paid out when customers purchase from your shop. Press the blue Stripe button if you want to do that now.
				<br /><br />
				Secondly, you need to add some products! Press the black products button to go through to your products page and start adding! Remember you'll still need to set up Stripe, which you can do at any time in your shop details page.
				<br/><br/>
				Thanks for trying <b className="featureFont">ORDERABL+</b>. If there's anything we can do to improve our service, or your experience, please let us know.
			</div>
			<div className="flexy wrapping buttons" style={{ margin: -10 }}>
				<div style={{ margin: 10, minWidth: 200 }}>
					<StripeButton />
				</div>
				<button style={{ margin: 10, minWidth: 200 }} onClick={e => history.push("/me/shop/products")}> Add Products</button>
			</div>
		</div>
	</div>
}